import { drinks } from './drinks'
import { drinksections } from './drinkssection'
import { events } from './events'
import { foods } from './foods'
import { foodsupselling } from './foodsupselling'
import { kampaayers } from './kampaayers'
import { musics } from './musics'
import { pmi } from './pmi'
import { suppliers } from './suppliers'
import { rents } from './rents'
import { transaction } from 'services/csv/entities/transaction'
import { virtuals } from 'services/csv/entities/virtual'
import { physicals } from 'services/csv/entities/physical'
import { virtualupselling } from './virtualupselling'
import { logistics } from './logistics'
import { professionals } from './professionalfigures'
import { APIEntity } from 'services/api/entities'
import { locations } from './locations'
import { locationupselling } from './locationupselling'
import { physicalupselling } from './physicalupselling'
import { locationfeatures } from './locationfeatures'
import { organization } from './organizations'
import { drinkpackages } from './drinkpackages'
import { KampaayDataProvider } from 'services/api/dataProvider'

export type EntityDescriptor<T = any> = {
  format: (
    dataProvider?: KampaayDataProvider
  ) => (record: T) => Promise<Object> | Object
  headers?: string[]
}

const ENTITIES: Partial<Record<APIEntity, EntityDescriptor>> = {
  drinks,
  drinksections,
  drinkpackages,
  events,
  eventsdraft: events,
  foods,
  foodsupselling,
  kampaayers,
  musics,
  locations,
  locationupselling,
  pmi,
  suppliers,
  rents,
  transaction,
  virtuals,
  virtualupselling,
  logistics,
  professionals,
  physicals,
  physicalupselling,
  locationfeatures,
  organization,
}

export default ENTITIES
